import axios from 'axios';

import { encodeProductPathSegment } from '@apple/utils/url';

import { productSelectionResponseSchema } from '../models/products';

/** @see AppleRetail.Web.ApiControllers.ShopProductSelectionApiController.GetProductSelection */
export async function getProductSelections(signal?: AbortSignal) {
	const { data } = await axios.get<unknown>('/api/shop/product-selection', { signal });
	return productSelectionResponseSchema.parse(data);
}

/**
 * @see AppleRetail.Web.ApiControllers.ShopProductSelectionApiController.AddProductToSelection
 * @see AppleRetail.Web.ApiControllers.ShopProductSelectionApiController.RemoveProductFromSelection
 */
export async function setProductSelection(
	itemId: string,
	selected: boolean,
	searchId?: string,
	position?: number,
	quantity?: number,
) {
	const { data } = selected
		? await axios.post<unknown>(
				`/api/shop/product-selection/${encodeProductPathSegment(itemId)}`,
				{
					searchId,
					position,
					quantity,
				},
			)
		: await axios.delete<unknown>(
				`/api/shop/product-selection/${encodeProductPathSegment(itemId)}`,
			);
	return productSelectionResponseSchema.parse(data);
}

/** @see AppleRetail.Web.ApiControllers.ShopProductSelectionApiController.ClearAllProductsFromSelection */
export async function clearProductSelections() {
	const { data } = await axios.delete<unknown>('/api/shop/product-selection/all');
	return productSelectionResponseSchema.parse(data);
}
